import * as go from 'gojs';
import {
  CONVERSIONS,
  convertToCurrentMetric,
  getMetricUnit,
} from 'util/conversions';

const $ = go.GraphObject.make;

/**
 * Template for displaying unit info data
 */
export const OutputFlowPanel = () =>
  $(
    go.TextBlock,
    {
      stroke: '#fff',
      alignment: go.Spot.Bottom,
      margin: new go.Margin(0, 4, 0, 4),
    },
    new go.Binding('text', '', (node) => {
      if (!node.massFlows) {
        return null;
      }
      if (node.showProductPercentage) {
        return `${convertToCurrentMetric({
          value: node.retainedAmount,
          metricType: node.metricType,
          conversionType: CONVERSIONS.CAPACITY,
          decimals: 0,
        })} ${getMetricUnit(node.metricType, CONVERSIONS.CAPACITY)}${
          Number.isFinite(node.productPercentage)
            ? `, ${node.productPercentage}%`
            : ''
        }`;
      }

      return `${convertToCurrentMetric({
        value: node.retainedAmount,
        metricType: node.metricType,
        conversionType: CONVERSIONS.CAPACITY,
        decimals: 0,
      })} ${getMetricUnit(node.metricType, CONVERSIONS.CAPACITY)}`;
    }),
    new go.Binding('font', '', (data, node) => {
      const canvasBodyFontSize = node.part.data.canvasBodyFontSize;
      return `normal normal 500 ${canvasBodyFontSize.size}px Sandvik Sans Text`;
    }),
  );
